import React from 'react';
import { Text } from '../../../Text/Text';

export const GroupHeading: React.FC = ({ children }) => {
  return (
    <Text variant="smallCaps" px="8" py="4">
      {children}
    </Text>
  );
};
